import React from 'react'

export default function AppLayout({children}) {
    return (
        <div className='AppLayout'>
            {children}
        </div>
    )
}
